export default __webpack_public_path__ + "static/media/flujo-continuo-timeout.ce325a70.png";